import React from "react";
import { IEditHistoryActionItem } from "../../../interfaces/EditHistory/IEditHistoryActionItem";
import moment from "moment";
import AddIcon from "../../Shared/Icons/AddIcon";

const ItemCreated = ({ activity }: IEditHistoryActionItem) => (
    <div className={`flex flex-wrap items-center border my-2 rounded`}>
        <div className="w-6 ml-2 bg-green-500 rounded-full">
            <AddIcon className="w-6 text-white p-1" />
        </div>
        <div className={`flex flex-col justify-between p-2 text-base`}>
            <div className="flex items-center text-sm">
                <div className="underline mr-1">{activity?.subjectType}</div> was created
            </div>
            <div className="text-xs text-gray-600">
                {[activity.causer?.firstName, activity.causer?.lastName].join(" ").trim()} •{" "}
                {moment(activity.createdAt).format("MMMM Do YYYY, h:mm a")}
            </div>
        </div>
    </div>
);

export default ItemCreated;
